// import React, { useRef, useState, useEffect } from "react";
// import {
//   Box,
//   Paper,
//   Table,
//   TableBody,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   IconButton,
// } from "@mui/material";
// import { useReactToPrint } from "react-to-print";
// import { Radio, RadioGroup, FormControlLabel } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";

// import styles from "../../../styles.module.css"; // Adjust path as needed
// import {
//   Breadcrumb,
//   StyledTableCell,
//   StyledTableRow,
// } from "../../reusableComponent/Reusables"; // Adjust path as needed
// import HeaderSection from "../../reusableComponent/HeaderSection"; // Adjust path as needed
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar"; // Adjust path as needed
// import cylinder_inventory_report from "../../../services/report/cylinder_inventory_report"; // Adjust path as needed

// const EmptyCylinderInv = () => {
//   const [searchKey, setSearchKey] = useState("");
//   const [selectedPlant, setSelectedPlant] = useState("");
//   const [selectedDepot, setSelectedDepot] = useState("");
//   const [plants, setPlants] = useState([]);
//   const [depots, setDepots] = useState([]);
//   const [controller, setController] = useState({
//     page: 0,
//     rowsPerPage: 10,
//   });
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [rows, setRows] = useState([]);
//   const [filterType, setFilterType] = useState("all"); // "all" | "plant" | "depot"
//   const [openDetail, setOpenDetail] = useState(false);
//   const [dialogData, setDialogData] = useState([]);
//   const [dialogTitle, setDialogTitle] = useState("");

//   // Fetch data and extract unique plants and depots
//   const fetchData = async () => {
//     try {
//       setSuccessMessage(null);
//       const params = {
//         page: controller.page,
//         size: controller.rowsPerPage,
//         searchKey: searchKey || undefined,
//         plant: selectedPlant || undefined,
//         depot: selectedDepot || undefined,
//       };
//       const response = await cylinder_inventory_report.getcylinderinventoryreport(params);

//       // Process rows to calculate under_maintaince if not provided by backend
//       const processedRows = response.map((row) => ({
//         ...row,
//         under_maintaince: row.cylinders
//           ? row.cylinders.filter((cylinder) => cylinder.storage === "MAINTENANCEYARD").length
//           : row.under_maintaince || 0, // Use backend-provided value if available
//       }));

//       setRows(processedRows || []);
//       const uniquePlants = [...new Set(processedRows.map((row) => row.plant_name).filter(Boolean))];
//       const uniqueDepots = [...new Set(processedRows.map((row) => row.depot_name).filter(Boolean))];
//       setPlants(uniquePlants);
//       setDepots(uniqueDepots);
//     } catch (error) {
//       setRows([]);
//       setPlants([]);
//       setDepots([]);
//       setSuccessMessage("Error fetching data");
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, [controller.page, controller.rowsPerPage, searchKey, selectedPlant, selectedDepot]);

//   const handleChangePage = (event, newPage) => {
//     setController((prev) => ({ ...prev, page: newPage }));
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setController({
//       ...controller,
//       rowsPerPage: parseInt(event.target.value, 10),
//       page: 0,
//     });
//   };

//   const handleSearch = (e) => {
//     setSearchKey(e.target.value);
//   };

//   const handlePlantChange = (e) => {
//     setSelectedPlant(e.target.value);
//     setController((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleDepotChange = (e) => {
//     setSelectedDepot(e.target.value);
//     setController((prev) => ({ ...prev, page: 0 }));
//   };

//   // Handle click on Total, Full, Empty, or Under Maintenance counts
//   const handleCountClick = (row, type) => {
//     let filteredCylinders = row.cylinders || [];
//     if (type === "full") {
//       filteredCylinders = filteredCylinders.filter((cylinder) => cylinder.status === "Full");
//       setDialogTitle(`Full Cylinders at ${row.plant_name || row.depot_name || "Location"}`);
//     } else if (type === "empty") {
//       filteredCylinders = filteredCylinders.filter((cylinder) => cylinder.status === "Empty");
//       setDialogTitle(`Empty Cylinders at ${row.plant_name || row.depot_name || "Location"}`);
//     } else if (type === "maintenance") {
//       filteredCylinders = filteredCylinders.filter((cylinder) => cylinder.storage === "MAINTENANCEYARD");
//       setDialogTitle(`Under Maintenance Cylinders at ${row.plant_name || row.depot_name || "Location"}`);
//     } else {
//       setDialogTitle(`All Cylinders at ${row.plant_name || row.depot_name || "Location"}`);
//     }
//     setDialogData(filteredCylinders);
//     setOpenDetail(true);
//   };

//   const handleClose = () => {
//     setOpenDetail(false);
//     setDialogData([]);
//     setDialogTitle("");
//   };

//   // Search and plant/depot filtering
//   const filteredRows = rows.filter((row) => {
//     const matchesSearch =
//       (row.plant_name?.toLowerCase().includes(searchKey.toLowerCase()) || false) ||
//       (row.depot_name?.toLowerCase().includes(searchKey.toLowerCase()) || false);

//     if (filterType === "plant") {
//       const hasPlant = !!row.plant_name;
//       const matchPlant = selectedPlant ? row.plant_name === selectedPlant : true;
//       return hasPlant && matchPlant && matchesSearch;
//     }

//     if (filterType === "depot") {
//       const hasDepot = !!row.depot_name;
//       const matchDepot = selectedDepot ? row.depot_name === selectedDepot : true;
//       return hasDepot && matchDepot && matchesSearch;
//     }

//     return matchesSearch;
//   });

//   // Pagination logic
//   const start = controller.page * controller.rowsPerPage;
//   const end = start + controller.rowsPerPage;
//   const paginatedRows = filteredRows.slice(start, end);
//   const paginationInfo = `${start + 1}-${Math.min(end, filteredRows.length)} of ${filteredRows.length}`;

//   const printRef = useRef();
//   const printFunction = useReactToPrint({
//     content: () => printRef.current,
//     documentTitle: "Empty Cylinder Report",
//     removeAfterPrint: true,
//   });

//   const handlePrint = () => {
//     printFunction();
//   };

//   return (
//     <Box className={styles.cts_page}>
//       <Box className={styles.body}>
//         <Breadcrumb routeSegments={[{ name: "Inventory Report" }]} />

//         <HeaderSection
//           title="INVENTORY REPORT"
//           searchKey={searchKey}
//           handleSearch={handleSearch}
//           sortedRows={filteredRows}
//           fields={[]}
//           labels={[]}
//           filename="Empty Cylinder Report"
//           paginationInfo={paginationInfo}
//           controller={controller}
//           handleChangePage={handleChangePage}
//           showAddButton={false}
//           PrintIcon_print={{ onClick: handlePrint }}
//         />

//         <Box sx={{ display: "flex", gap: 2, marginBottom: 2, alignItems: "center" }}>
//           <FormControl>
//             <RadioGroup
//               row
//               value={filterType}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 setFilterType(value);
//                 setSelectedPlant("");
//                 setSelectedDepot("");
//               }}
//             >
//               <FormControlLabel
//                 value="all"
//                 control={
//                   <Radio
//                     sx={{
//                       color: "#555",
//                       "&.Mui-checked": { color: "#1976d2" },
//                       transform: "scale(1.1)",
//                     }}
//                   />
//                 }
//                 label="All"
//               />
//               <FormControlLabel
//                 value="plant"
//                 control={
//                   <Radio
//                     sx={{
//                       color: "#555",
//                       "&.Mui-checked": { color: "#1976d2" },
//                       transform: "scale(1.1)",
//                     }}
//                   />
//                 }
//                 label="Plant"
//               />
//               <FormControlLabel
//                 value="depot"
//                 control={
//                   <Radio
//                     sx={{
//                       color: "#555",
//                       "&.Mui-checked": { color: "#1976d2" },
//                       transform: "scale(1.1)",
//                     }}
//                   />
//                 }
//                 label="Depot"
//               />
//             </RadioGroup>
//           </FormControl>

//           {filterType === "plant" && (
//             <FormControl sx={{ width: 150 }} size="small">
//               <InputLabel>Plant</InputLabel>
//               <Select value={selectedPlant} onChange={handlePlantChange} label="Plant">
//                 <MenuItem value="">All Plants</MenuItem>
//                 {plants.map((plant) => (
//                   <MenuItem key={plant} value={plant}>
//                     {plant}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           )}

//           {filterType === "depot" && (
//             <FormControl sx={{ width: 150 }} size="small">
//               <InputLabel>Depot</InputLabel>
//               <Select value={selectedDepot} onChange={handleDepotChange} label="Depot">
//                 <MenuItem value="">All Depots</MenuItem>
//                 {depots.map((depot) => (
//                   <MenuItem key={depot} value={depot}>
//                     {depot}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           )}
//         </Box>

//         <Paper className={styles.table_container}>
//           {/* Printable Table (All Rows for Printing) */}
//           <Box
//             ref={printRef}
//             sx={{
//               display: "none",
//               "@media print": {
//                 display: "block",
//               },
//               position: "relative",
//               zIndex: 0,
//               width: "100%",
//               padding: 4,
//               backgroundColor: "#fff",
//             }}
//           >
//             <div style={{ fontFamily: "Arial, sans-serif" }}>
//               <h1 style={{ textAlign: "left", fontSize: "20px", marginBottom: "10px" }}>
//                 Empty Cylinder Report
//               </h1>
//               <p style={{ textAlign: "left", fontSize: "12px", marginBottom: "20px" }}>
//                 Generated on {new Date().toLocaleDateString()}
//               </p>
//               <Table size="small" stickyHeader>
//                 <TableHead>
//                   <StyledTableRow>
//                     <StyledTableCell>Location</StyledTableCell>
//                     <StyledTableCell>Product Code</StyledTableCell>
//                     <StyledTableCell>Total No of Cylinder</StyledTableCell>
//                     <StyledTableCell>Full</StyledTableCell>
//                     <StyledTableCell>Empty</StyledTableCell>
//                     <StyledTableCell>Under Maintenance</StyledTableCell>
//                   </StyledTableRow>
//                 </TableHead>
//                 <TableBody>
//                   {filteredRows.map((row, index) => (
//                     <StyledTableRow key={index}>
//                       <StyledTableCell>{row.plant_name || row.depot_name || "-"}</StyledTableCell>
//                       <StyledTableCell>{row.prod_code || "-"}</StyledTableCell>
//                       <StyledTableCell>{row.total_cylinders || 0}</StyledTableCell>
//                       <StyledTableCell>{row.full_cylinders || 0}</StyledTableCell>
//                       <StyledTableCell>{row.empty_cylinders || 0}</StyledTableCell>
//                       <StyledTableCell>{row.under_maintaince || 0}</StyledTableCell>
//                     </StyledTableRow>
//                   ))}
//                 </TableBody>
//               </Table>
              
//             </div>
//           </Box>

//           {/* Display Table (Paginated) */}
//           <TableContainer component={Paper} className={styles.list_tbl_container}>
//             <Table size="small" stickyHeader>
//               <TableHead>
//                 <StyledTableRow>
//                   <StyledTableCell align="left">Location</StyledTableCell>
//                   <StyledTableCell align="left">Product Code</StyledTableCell>
//                   <StyledTableCell align="left">Total No of Cylinder</StyledTableCell>
//                   <StyledTableCell align="left">Full</StyledTableCell>
//                   <StyledTableCell align="left">Empty</StyledTableCell>
//                   <StyledTableCell align="left">Under Maintenance</StyledTableCell>
//                 </StyledTableRow>
//               </TableHead>
//               <TableBody sx={{ backgroundColor: "#fff" }}>
//                 {paginatedRows.map((row, index) => (
//                   <StyledTableRow key={index}>
//                     <StyledTableCell align="left" className={styles.inspection_cell}>
//                       {row.plant_name || row.depot_name || "-"}
//                     </StyledTableCell>
//                     <StyledTableCell align="left" className={styles.inspection_cell}>
//                       {row.prod_code || "-"}
//                     </StyledTableCell>
//                     <StyledTableCell
//                       align="left"
//                       className={styles.inspection_cell}
//                       sx={{ cursor: "pointer", color: "#1976d2" }}
//                       onClick={() => handleCountClick(row, "total")}
//                     >
//                       {row.total_cylinders || 0}
//                     </StyledTableCell>
//                     <StyledTableCell
//                       align="left"
//                       className={styles.inspection_cell}
//                       sx={{ cursor: "pointer", color: "#1976d2" }}
//                       onClick={() => handleCountClick(row, "full")}
//                     >
//                       {row.full_cylinders || 0}
//                     </StyledTableCell>
//                     <StyledTableCell
//                       align="left"
//                       className={styles.inspection_cell}
//                       sx={{ cursor: "pointer", color: "#1976d2" }}
//                       onClick={() => handleCountClick(row, "empty")}
//                     >
//                       {row.empty_cylinders || 0}
//                     </StyledTableCell>
//                     <StyledTableCell
//                       align="left"
//                       className={styles.inspection_cell}
//                       sx={{ cursor: "pointer", color: "#1976d2" }}
//                       onClick={() => handleCountClick(row, "maintenance")}
//                     >
//                       {row.under_maintaince || 0}
//                     </StyledTableCell>
//                   </StyledTableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>

//           <TablePagination
//             className={styles.no_print}
//             component="div"
//             count={filteredRows.length}
//             page={controller.page}
//             onPageChange={handleChangePage}
//             rowsPerPage={controller.rowsPerPage}
//             onRowsPerPageChange={handleChangeRowsPerPage}
//           />
//         </Paper>

//         {/* Dialog for Cylinder Details */}
//         <Dialog
//           PaperProps={{
//             sx: {
//               minWidth: "90%",
//               maxHeight: "90%",
//             },
//           }}
//           onClose={handleClose}
//           open={openDetail}
//         >
//           <DialogTitle id="customized-dialog-title">
//             {dialogTitle}
//             <IconButton
//               aria-label="close"
//               onClick={handleClose}
//               sx={{
//                 position: "absolute",
//                 right: 8,
//                 top: 8,
//               }}
//             >
//               <CloseIcon />
//             </IconButton>
//           </DialogTitle>
//           <DialogContent dividers>
//             <TableContainer component={Paper} className={`${styles.list_tbl_container} printable-table`}>
//               <Table size="small" stickyHeader className="printable-table">
//                 <TableHead className={styles.table_head_container}>
//                   <StyledTableRow>
//                     <StyledTableCell align="center">Sr No</StyledTableCell>
//                     <StyledTableCell align="left">Cylinder No</StyledTableCell>
//                     <StyledTableCell align="left">Tag No</StyledTableCell>
//                     <StyledTableCell align="left">Owner</StyledTableCell>
//                     <StyledTableCell align="left">Status</StyledTableCell>
//                     <StyledTableCell align="left">Note</StyledTableCell>
//                     <StyledTableCell align="left">Storage</StyledTableCell>
//                   </StyledTableRow>
//                 </TableHead>
//                 <TableBody sx={{ backgroundColor: "#fff" }}>
//                   {dialogData.map((row, index) => (
//                     <StyledTableRow key={index}>
//                       <StyledTableCell align="center">{index + 1}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {row.cylinder_no || "-"}
//                       </StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {row.tag_no || "-"}
//                       </StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {row.owner || "-"}
//                       </StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {row.status || "-"}
//                       </StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {row.note || "-"}
//                       </StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {row.storage || "-"}
//                       </StyledTableCell>
//                     </StyledTableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </DialogContent>
//         </Dialog>

//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={(event, reason) => {
//             if (reason !== "clickaway") {
//               setSuccessMessage("");
//             }
//           }}
//           message={successMessage}
//           autoHideDuration={2000}
//           vertical="top"
//           horizontal="right"
//         />
//       </Box>
//     </Box>
//   );
// };

// export default EmptyCylinderInv;


import React, { useRef, useState, useEffect } from "react";
import {
  Box, Button, Typography, Grid, Paper, Table, TableBody, TableContainer,
  TableHead, Dialog, DialogContent, IconButton, MenuItem, FormControl,
  Radio, RadioGroup, FormControlLabel, InputAdornment,
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import CloseIcon from "@mui/icons-material/Close";
import { Print, Search } from "@mui/icons-material";
import styles from "../../../styles.module.css";
import {
  Breadcrumb, CTSinput, StyledTableCell, StyledTableRow,
} from "../../reusableComponent/Reusables";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import CustomPagination from "../../reusableComponent/CustomPagination";
import cylinder_inventory_report from "../../../services/report/cylinder_inventory_report";
import { useSelector } from "react-redux";

const printStyles = `
  @media print {
    body * { visibility: hidden; }
    .printable-area, .printable-area * { visibility: visible; }
    .printable-area {
      position: absolute; left: 0; top: 0;
      width: 100%; overflow: visible !important;
      height: auto !important; max-height: none !important;
    }
    .printable-table {
      width: 100% !important;
      border-collapse: collapse !important;
      overflow: visible !important;
    }
    .printable-table thead { display: table-header-group; }
    .printable-table tbody { display: table-row-group; }
    .MuiPaper-root, .MuiTableContainer-root {
      overflow: visible !important;
      max-height: none !important;
      box-shadow: none !important;
    }
    .no-print { display: none !important; }
    .print-header-info { display: block !important; margin-bottom: 10px; }
  }
  .print-header-info { display: none; }
`;

const EmptyCylinderInv = () => {
  const defaultRowsPerPage = useSelector(state => state.grn?.rows_per_page || 15);

  const [searchKey, setSearchKey]         = useState("");
  const [selectedPlant, setSelectedPlant] = useState("");
  const [selectedDepot, setSelectedDepot] = useState("");
  const [plants, setPlants]               = useState([]);
  const [depots, setDepots]               = useState([]);
  const [rows, setRows]                   = useState([]);
  const [filterType, setFilterType]       = useState("all");
  const [openDetail, setOpenDetail]       = useState(false);
  const [dialogData, setDialogData]       = useState([]);
  const [dialogTitle, setDialogTitle]     = useState("");
  const [selectedRow, setSelectedRow]     = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [controller, setController] = useState({ page: 0, rowsPerPage: defaultRowsPerPage });

  // inject print styles
  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);
    return () => { document.head.removeChild(styleSheet); };
  }, []);

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey || undefined,
        plant: selectedPlant || undefined,
        depot: selectedDepot || undefined,
      };
      const response = await cylinder_inventory_report.getcylinderinventoryreport(params);
      const processedRows = response.map(row => ({
        ...row,
        under_maintaince: row.cylinders
          ? row.cylinders.filter(c => c.storage === "MAINTENANCEYARD").length
          : row.under_maintaince || 0,
      }));
      setRows(processedRows || []);
      setPlants([...new Set(processedRows.map(r => r.plant_name).filter(Boolean))]);
      setDepots([...new Set(processedRows.map(r => r.depot_name).filter(Boolean))]);
    } catch (error) {
      setRows([]);
      setSuccessMessage("Error fetching data");
    }
  };

  useEffect(() => {
    fetchData();
  }, [controller.page, controller.rowsPerPage, searchKey, selectedPlant, selectedDepot]);

  // filtered rows (client-side)
  const filteredRows = rows.filter(row => {
    const matchesSearch =
      (row.plant_name?.toLowerCase().includes(searchKey.toLowerCase()) || false) ||
      (row.depot_name?.toLowerCase().includes(searchKey.toLowerCase()) || false);
    if (filterType === "plant") {
      const matchPlant = selectedPlant ? row.plant_name === selectedPlant : true;
      return !!row.plant_name && matchPlant && matchesSearch;
    }
    if (filterType === "depot") {
      const matchDepot = selectedDepot ? row.depot_name === selectedDepot : true;
      return !!row.depot_name && matchDepot && matchesSearch;
    }
    return matchesSearch;
  });

  const totalCount = filteredRows.length;

  const handleCountClick = (row, type) => {
    let filtered = row.cylinders || [];
    if (type === "full")        { filtered = filtered.filter(c => c.status === "Full");                    setDialogTitle(`Full Cylinders — ${row.plant_name || row.depot_name || "Location"}`); }
    else if (type === "empty")  { filtered = filtered.filter(c => c.status === "Empty");                   setDialogTitle(`Empty Cylinders — ${row.plant_name || row.depot_name || "Location"}`); }
    else if (type === "maintenance") { filtered = filtered.filter(c => c.storage === "MAINTENANCEYARD");   setDialogTitle(`Under Maintenance — ${row.plant_name || row.depot_name || "Location"}`); }
    else                        {                                                                           setDialogTitle(`All Cylinders — ${row.plant_name || row.depot_name || "Location"}`); }
    setSelectedRow(row);
    setDialogData(filtered);
    setOpenDetail(true);
  };

  const handleClose = () => { setOpenDetail(false); setDialogData([]); setDialogTitle(""); setSelectedRow(null); };

  const handleChangePage        = (e, newPage) => setController(prev => ({ ...prev, page: newPage }));
  const handleChangeRowsPerPage = (e)          => setController({ rowsPerPage: parseInt(e.target.value, 10), page: 0 });

  const printRef = useRef();
  const printFunction = useReactToPrint({ content: () => printRef.current, documentTitle: "Inventory Report", removeAfterPrint: true });
  const handlePrint = () => printFunction();

  const cylinderHeaders = ["Sr No", "Cylinder No", "Tag No", "Owner", "Status", "Remark", "location"];

  const mainHeaders = ["Location","Total No of Cylinder", "Full", "Empty", "Under Maintenance"];

  return (
    <Box className={styles.cts_page} sx={{ padding: "0px !important", margin: "0px !important" }}>
      <Box className={styles.body}>
        <Breadcrumb routeSegments={[{ name: "Inventory Report" }]} />
        <Typography className={styles.header_txt}>INVENTORY SUMMARY</Typography>

        {/* ── Filter Row ── */}
        <Box
          className="no-print"
          sx={{ display: "flex", flexWrap: "wrap", alignItems: "flex-end", gap: "12px", mb: 2, width: "100%" }}
        >
          {/* Search */}
          <Box sx={{ display: "flex", flexDirection: "column", flex: "1 1 180px", minWidth: "180px", maxWidth: { xs: "100%", sm: "260px" } }}>
            <Typography sx={{ fontSize: "12px", fontWeight: 500, color: "text.secondary", mb: "4px", whiteSpace: "nowrap" }}>
              Search
            </Typography>
            <CTSinput
              size="small" fullWidth
              placeholder="Search location..."
              value={searchKey}
              onChange={e => { setSearchKey(e.target.value); setController(prev => ({ ...prev, page: 0 })); }}
              InputProps={{
                className: styles.CTSinput_Box,
                startAdornment: <InputAdornment position="start"><Search sx={{ fontSize: 16, color: "text.secondary" }} /></InputAdornment>,
              }}
            />
          </Box>

          {/* Filter Type Radio */}
          <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-end", flex: "0 0 auto" }}>
            <Typography sx={{ fontSize: "12px", fontWeight: 500, color: "text.secondary", mb: "4px" }}>Filter By</Typography>
            <FormControl>
              <RadioGroup row value={filterType}
                onChange={e => { setFilterType(e.target.value); setSelectedPlant(""); setSelectedDepot(""); }}
              >
                {["all", "plant", "depot"].map(val => (
                  <FormControlLabel key={val} value={val}
                    label={<Typography sx={{ fontSize: "12px", textTransform: "capitalize" }}>{val}</Typography>}
                    control={<Radio sx={{ color: "#555", "&.Mui-checked": { color: "#1976d2" }, transform: "scale(0.9)", p: "4px" }} />}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Box>

          {/* Plant dropdown */}
          {filterType === "plant" && (
            <Box sx={{ display: "flex", flexDirection: "column", flex: "1 1 150px", minWidth: "150px", maxWidth: { xs: "100%", sm: "220px" } }}>
              <Typography sx={{ fontSize: "12px", fontWeight: 500, color: "text.secondary", mb: "4px" }}>Plant</Typography>
              <CTSinput select size="small" fullWidth value={selectedPlant}
                onChange={e => { setSelectedPlant(e.target.value); setController(prev => ({ ...prev, page: 0 })); }}
                InputProps={{ className: styles.CTSinput_Box }}
              >
                <MenuItem value="">All Plants</MenuItem>
                {plants.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
              </CTSinput>
            </Box>
          )}

          {/* Depot dropdown */}
          {filterType === "depot" && (
            <Box sx={{ display: "flex", flexDirection: "column", flex: "1 1 150px", minWidth: "150px", maxWidth: { xs: "100%", sm: "220px" } }}>
              <Typography sx={{ fontSize: "12px", fontWeight: 500, color: "text.secondary", mb: "4px" }}>Depot</Typography>
              <CTSinput select size="small" fullWidth value={selectedDepot}
                onChange={e => { setSelectedDepot(e.target.value); setController(prev => ({ ...prev, page: 0 })); }}
                InputProps={{ className: styles.CTSinput_Box }}
              >
                <MenuItem value="">All Depots</MenuItem>
                {depots.map(d => <MenuItem key={d} value={d}>{d}</MenuItem>)}
              </CTSinput>
            </Box>
          )}

          {/* Print button */}
          <Box sx={{ display: "flex", alignItems: "flex-end", flex: "0 0 auto" }}>
            <Button
              variant="outlined" startIcon={<Print />} onClick={handlePrint}
              disabled={filteredRows.length === 0} size="small"
              sx={{ whiteSpace: "nowrap", height: "30px" }}
            >
              Print
            </Button>
          </Box>
        </Box>

        {/* ── Main Table ── */}
        <Grid item xs={12}>
          <Paper sx={{ width: "100%" }}>
           <div className="printable-area" ref={printRef}>
              {/* Print header */}
              <div className="print-header-info" style={{ marginBottom: "20px" }}>
                <Typography variant="h4" align="left" sx={{ fontWeight: "bold" }}>Inventory Report</Typography>
                <Typography variant="body1" align="left" sx={{ marginTop: 1 }}>
                  Filter: {filterType === "plant" ? `Plant — ${selectedPlant || "All"}` : filterType === "depot" ? `Depot — ${selectedDepot || "All"}` : "All"}
                </Typography>
              </div>

              <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
                <Table size="small" stickyHeader className="printable-table">
                  <TableHead>
                    <StyledTableRow>
                      {mainHeaders.map(h => (
                        <StyledTableCell key={h}  align={h === "Under Maintenance" ? "center" : "left"} sx={{ 
      textAlign: h === "Under Maintenance" ? "center !important" : "left !important", 
      paddingLeft: h === "Under Maintenance" ? "0px" : "0px", 
      whiteSpace: "nowrap" 
    }}>{h}</StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody sx={{ backgroundColor: "#fff" }}>
                    {filteredRows.length === 0 ? (
                      <StyledTableRow>
                        <StyledTableCell colSpan={mainHeaders.length} align="center">
                          <Typography>No data found</Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                    ) : (
                      filteredRows
                        .slice(controller.page * controller.rowsPerPage, (controller.page + 1) * controller.rowsPerPage)
                        .map((row, index) => (
                          <StyledTableRow key={index}>
                            {/* Location */}
                            <StyledTableCell className={styles.inspection_cell} sx={{ whiteSpace: "nowrap" }}>
                              {row.plant_name || row.depot_name || "-"}
                            </StyledTableCell>

                            {/* Product Code */}
                            {/* <StyledTableCell className={styles.inspection_cell} sx={{ whiteSpace: "nowrap" }}>
                              {row.prod_code || "-"}
                            </StyledTableCell> */}

                            {/* Total — clickable */}
                            <StyledTableCell onClick={() => handleCountClick(row, "total")} sx={{ whiteSpace: "nowrap" }}>
                              <Typography sx={{ fontSize: "12px", fontWeight: "bold", cursor: "pointer", color: "#1976d2 !important", textDecoration: "underline" }}>
                                {row.total_cylinders || 0}
                              </Typography>
                            </StyledTableCell>

                            {/* Full — clickable */}
                            <StyledTableCell onClick={() => handleCountClick(row, "full")} sx={{ whiteSpace: "nowrap" }}>
                              <Typography sx={{ fontSize: "12px", fontWeight: "bold", cursor: "pointer", color: "#1976d2 !important", textDecoration: "underline" }}>
                                {row.full_cylinders || 0}
                              </Typography>
                            </StyledTableCell>

                            {/* Empty — clickable */}
                            <StyledTableCell onClick={() => handleCountClick(row, "empty")} sx={{ whiteSpace: "nowrap" }}>
                              <Typography sx={{ fontSize: "12px", fontWeight: "bold", cursor: "pointer", color: "#1976d2 !important", textDecoration: "underline" }}>
                                {row.empty_cylinders || 0}
                              </Typography>
                            </StyledTableCell>

                            {/* Under Maintenance — clickable */}
                            <StyledTableCell  align="center" onClick={() => handleCountClick(row, "maintenance")} sx={{ whiteSpace: "nowrap" }}>
                              <Typography sx={{ fontSize: "12px", fontWeight: "bold", cursor: "pointer", color: "#1976d2 !important", textDecoration: "underline" }}>
                                {row.under_maintaince || 0}
                              </Typography>
                            </StyledTableCell>
                          </StyledTableRow>
                        ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

            <CustomPagination
              page={controller.page}
              rowsPerPage={controller.rowsPerPage}
              totalCount={totalCount}
              onPageChange={(newPage) => handleChangePage(null, newPage)}
              onRowsPerPageChange={handleChangeRowsPerPage}
              className="no-print"
            />
          </Paper>
        </Grid>

        {/* ── Snackbar ── */}
        <ReusableSnackbar
          open={!!successMessage} onClose={() => setSuccessMessage("")}
          message={successMessage} autoHideDuration={2000}
          vertical="top" horizontal="right" className="no-print"
        />

        {/* ── Detail Dialog ── */}
        <Dialog
          open={openDetail} onClose={handleClose} maxWidth={false} className="no-print"
          sx={{
            "& .MuiDialog-paper": {
              margin: "auto", width: "92vw", maxHeight: "85vh",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              overflow: "hidden", fontFamily: "'Inter', Arial, sans-serif",
            },
          }}
        >
          {/* Header */}
          <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.5px", fontFamily: "'Inter', Arial, sans-serif" }}>
              CYLINDER DETAILS
            </Typography>
            <IconButton onClick={handleClose} sx={{ color: "#fff", p: 0.5 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={{ padding: "20px 24px", background: "#F4F7FB", overflowY: "auto" }}>

            {/* ── Location Info Card ── */}
            {/* <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden", mb: 2.5 }}>
              <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", letterSpacing: "0.4px", fontFamily: "'Inter', Arial, sans-serif" }}>
                  📋 Location Information
                </Typography>
              </Box>
              <Grid container>
                {[
                  { label: "Location",          value: selectedRow?.plant_name || selectedRow?.depot_name, border: true,  bottom: false },
                  { label: "Product Code",       value: selectedRow?.prod_code,                            border: true,  bottom: false },
                  { label: "Total Cylinders",    value: selectedRow?.total_cylinders,                      border: true,  bottom: false },
                  { label: "Full",               value: selectedRow?.full_cylinders,                       border: true,  bottom: false },
                  { label: "Empty",              value: selectedRow?.empty_cylinders,                      border: true,  bottom: false },
                  { label: "Under Maintenance",  value: selectedRow?.under_maintaince,                     border: false, bottom: false },
                ].map(({ label, value, border, bottom }) => (
                  <Grid key={label} item xs={12} sm={6} md={2}
                    sx={{ borderRight: border ? "1px solid #EDF2F7" : "none", borderBottom: bottom ? "1px solid #EDF2F7" : "none", padding: "12px 16px" }}
                  >
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      {label}
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: label === "Location" ? 700 : 600, color: label === "Location" ? "#1C3A5E" : "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {value ?? "N/A"}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </Box> */}

            {/* ── Cylinder Details Table ── */}
            <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden" }}>
              {/* <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", letterSpacing: "0.4px", fontFamily: "'Inter', Arial, sans-serif" }}>
                  🛢️ Cylinder Details — {dialogTitle}
                </Typography>
              </Box> */}
              <TableContainer sx={{ maxHeight: "350px" }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <StyledTableRow>
                      {cylinderHeaders.map(header => (
                        <StyledTableCell key={header} align="center"
                          sx={{ backgroundColor: "#1C3A5E !important", color: "#fff !important", fontFamily: "'Inter', Arial, sans-serif", fontWeight: 700, fontSize: "11px", padding: "10px 8px", whiteSpace: "nowrap", borderRight: "1px solid rgba(255,255,255,0.1)" }}
                        >
                          {header}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {dialogData.length > 0 ? (
                      dialogData.map((row, index) => (
                        <StyledTableRow key={index}
                          sx={{ backgroundColor: index % 2 === 0 ? "#fff" : "#F8FAFC", "&:hover": { backgroundColor: "#EBF4FF" } }}
                        >
                          {[index + 1, row.cylinder_no || "N/A", row.tag_no || "N/A", row.owner || "N/A", row.status || "N/A", row.note || "N/A", row.storage || "N/A"].map((val, ci) => (
                            <StyledTableCell key={ci} align="center"
                              sx={{ fontSize: "11px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", padding: "8px 6px", borderBottom: "1px solid #EDF2F7", whiteSpace: "nowrap" }}
                            >
                              {val}
                            </StyledTableCell>
                          ))}
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell colSpan={cylinderHeaders.length} align="center"
                          sx={{ py: 5, fontSize: "13px", color: "#A0AEC0", fontFamily: "'Inter', Arial, sans-serif" }}
                        >
                          No cylinder details available
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </DialogContent>

          {/* Footer */}
          <Box sx={{ padding: "12px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={handleClose}
              sx={{ background: "#E53E3E", color: "#fff", fontSize: "13px", fontWeight: 600, textTransform: "none", padding: "7px 20px", borderRadius: "8px", fontFamily: "'Inter', Arial, sans-serif", "&:hover": { background: "#971f16" } }}
            >
              Close
            </Button>
          </Box>
        </Dialog>

      </Box>
    </Box>
  );
};

export default EmptyCylinderInv;